export function formatDateKey(dateObj) {
  const y = dateObj.getFullYear();
  const m = String(dateObj.getMonth() + 1).padStart(2, "0");
  const d = String(dateObj.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function buildLast7DaysLogSeries(chartData) {
  const oneDay = 24 * 60 * 60 * 1000;
  const now = new Date();
  const dates = Array.from({ length: 7 }, (_, i) => new Date(now - (6 - i) * oneDay));
  const labels = dates.map((date) => date.toLocaleDateString("ru-RU"));
  const keys = dates.map(formatDateKey);

  const logsMap = (Array.isArray(chartData?.labels) ? chartData.labels : []).reduce((acc, rawDate, idx) => {
    const parsed = rawDate instanceof Date ? rawDate : new Date(rawDate);
    if (Number.isNaN(parsed.getTime())) return acc;
    acc[formatDateKey(parsed)] = (Array.isArray(chartData?.data) ? chartData.data[idx] : 0) || 0;
    return acc;
  }, {});

  return {
    labels,
    data: keys.map((key) => logsMap[key] || 0)
  };
}

export function buildRegistrationsChartData(registrations = []) {
  const oneDay = 24 * 60 * 60 * 1000;
  const now = new Date();
  const labels = Array.from({ length: 7 }, (_, i) => {
    const date = new Date(now - (6 - i) * oneDay);
    return date.toLocaleDateString("ru-RU");
  });

  return {
    labels,
    data: registrations
  };
}

export function buildPurchaseSeriesChartData(purchaseSeries = {}, colorMap = {}) {
  const labels = Array.isArray(purchaseSeries?.labels) ? purchaseSeries.labels : [];
  const series = Array.isArray(purchaseSeries?.series) ? purchaseSeries.series : [];

  return {
    labels,
    datasets: series.map((item) => {
      const color = colorMap[item.key] || "#7CE7FF";
      return {
        label: item.label || item.key,
        data: Array.isArray(item.data) ? item.data : [],
        borderColor: color,
        backgroundColor: `${color}33`,
        pointBackgroundColor: color,
        pointBorderColor: color,
        pointHoverBackgroundColor: color,
        pointHoverBorderColor: "#09111E",
        borderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5,
        tension: 0.32
      };
    })
  };
}
